/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from '@tanstack/react-router'

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as TechnicianIndexImport } from './routes/technician/index'
import { Route as ManagerIndexImport } from './routes/manager/index'
import { Route as BarcodeIndexImport } from './routes/barcode.index'
import { Route as TechnicianLayoutImport } from './routes/technician/_layout'
import { Route as ManagerLayoutImport } from './routes/manager/_layout'
import { Route as appLayoutImport } from './routes/(app)/_layout'
import { Route as authLoginIndexImport } from './routes/(auth)/login/index'
import { Route as authForgotPasswordIndexImport } from './routes/(auth)/forgot-password/index'
import { Route as authChangePasswordIndexImport } from './routes/(auth)/change-password/index'
import { Route as TechnicianLayoutWorklistIndexImport } from './routes/technician/_layout/worklist/index'
import { Route as TechnicianLayoutRequestAndReceiveIndexImport } from './routes/technician/_layout/request-and-receive/index'
import { Route as TechnicianLayoutExpiryTrackIndexImport } from './routes/technician/_layout/expiry-track/index'
import { Route as TechnicianLayoutDashboardIndexImport } from './routes/technician/_layout/dashboard/index'
import { Route as TechnicianLayoutCountAndVerifyIndexImport } from './routes/technician/_layout/count-and-verify/index'
import { Route as ManagerLayoutSalesAndRevenueIndexImport } from './routes/manager/_layout/sales-and-revenue/index'
import { Route as ManagerLayoutPrescriptionsIndexImport } from './routes/manager/_layout/prescriptions/index'
import { Route as ManagerLayoutInventoryIndexImport } from './routes/manager/_layout/inventory/index'
import { Route as ManagerLayoutEmployeePerformanceIndexImport } from './routes/manager/_layout/employee-performance/index'
import { Route as ManagerLayoutDashboardIndexImport } from './routes/manager/_layout/dashboard/index'
import { Route as appLayoutSettingsIndexImport } from './routes/(app)/_layout/settings/index'
import { Route as appLayoutPrescriptionHubIndexImport } from './routes/(app)/_layout/prescription-hub/index'
import { Route as appLayoutPatientsIndexImport } from './routes/(app)/_layout/patients/index'
import { Route as appLayoutInventoryIndexImport } from './routes/(app)/_layout/inventory/index'
import { Route as appLayoutDashboardIndexImport } from './routes/(app)/_layout/dashboard/index'
import { Route as appLayoutActivityIndexImport } from './routes/(app)/_layout/activity/index'
import { Route as appLayoutAccountsIndexImport } from './routes/(app)/_layout/accounts/index'
import { Route as ManagerLayoutInventoryItemIdImport } from './routes/manager/_layout/inventory/$itemId'
import { Route as ManagerLayoutEmployeePerformanceEmployeeIdImport } from './routes/manager/_layout/employee-performance/$employeeId'
import { Route as appLayoutInventoryItemIdIndexImport } from './routes/(app)/_layout/inventory/$itemId/index'
import { Route as appLayoutAccountsRevenueIndexImport } from './routes/(app)/_layout/accounts/revenue/index'
import { Route as appLayoutAccountsProfitLossIndexImport } from './routes/(app)/_layout/accounts/profit-loss/index'
import { Route as appLayoutAccountsCostOfGoodsIndexImport } from './routes/(app)/_layout/accounts/cost-of-goods/index'

// Create Virtual Routes

const TechnicianImport = createFileRoute('/technician')()
const ManagerImport = createFileRoute('/manager')()
const appImport = createFileRoute('/(app)')()

// Create/Update Routes

const TechnicianRoute = TechnicianImport.update({
  path: '/technician',
  getParentRoute: () => rootRoute,
} as any)

const ManagerRoute = ManagerImport.update({
  path: '/manager',
  getParentRoute: () => rootRoute,
} as any)

const appRoute = appImport.update({
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const TechnicianIndexRoute = TechnicianIndexImport.update({
  path: '/',
  getParentRoute: () => TechnicianRoute,
} as any)

const ManagerIndexRoute = ManagerIndexImport.update({
  path: '/',
  getParentRoute: () => ManagerRoute,
} as any)

const BarcodeIndexRoute = BarcodeIndexImport.update({
  path: '/barcode/',
  getParentRoute: () => rootRoute,
} as any)

const TechnicianLayoutRoute = TechnicianLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => TechnicianRoute,
} as any)

const ManagerLayoutRoute = ManagerLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => ManagerRoute,
} as any)

const appLayoutRoute = appLayoutImport.update({
  id: '/_layout',
  getParentRoute: () => appRoute,
} as any)

const authLoginIndexRoute = authLoginIndexImport.update({
  path: '/login/',
  getParentRoute: () => rootRoute,
} as any)

const authForgotPasswordIndexRoute = authForgotPasswordIndexImport.update({
  path: '/forgot-password/',
  getParentRoute: () => rootRoute,
} as any)

const authChangePasswordIndexRoute = authChangePasswordIndexImport.update({
  path: '/change-password/',
  getParentRoute: () => rootRoute,
} as any)

const TechnicianLayoutWorklistIndexRoute =
  TechnicianLayoutWorklistIndexImport.update({
    path: '/worklist/',
    getParentRoute: () => TechnicianLayoutRoute,
  } as any)

const TechnicianLayoutRequestAndReceiveIndexRoute =
  TechnicianLayoutRequestAndReceiveIndexImport.update({
    path: '/request-and-receive/',
    getParentRoute: () => TechnicianLayoutRoute,
  } as any)

const TechnicianLayoutExpiryTrackIndexRoute =
  TechnicianLayoutExpiryTrackIndexImport.update({
    path: '/expiry-track/',
    getParentRoute: () => TechnicianLayoutRoute,
  } as any)

const TechnicianLayoutDashboardIndexRoute =
  TechnicianLayoutDashboardIndexImport.update({
    path: '/dashboard/',
    getParentRoute: () => TechnicianLayoutRoute,
  } as any)

const TechnicianLayoutCountAndVerifyIndexRoute =
  TechnicianLayoutCountAndVerifyIndexImport.update({
    path: '/count-and-verify/',
    getParentRoute: () => TechnicianLayoutRoute,
  } as any)

const ManagerLayoutSalesAndRevenueIndexRoute =
  ManagerLayoutSalesAndRevenueIndexImport.update({
    path: '/sales-and-revenue/',
    getParentRoute: () => ManagerLayoutRoute,
  } as any)

const ManagerLayoutPrescriptionsIndexRoute =
  ManagerLayoutPrescriptionsIndexImport.update({
    path: '/prescriptions/',
    getParentRoute: () => ManagerLayoutRoute,
  } as any)

const ManagerLayoutInventoryIndexRoute =
  ManagerLayoutInventoryIndexImport.update({
    path: '/inventory/',
    getParentRoute: () => ManagerLayoutRoute,
  } as any)

const ManagerLayoutEmployeePerformanceIndexRoute =
  ManagerLayoutEmployeePerformanceIndexImport.update({
    path: '/employee-performance/',
    getParentRoute: () => ManagerLayoutRoute,
  } as any)

const ManagerLayoutDashboardIndexRoute =
  ManagerLayoutDashboardIndexImport.update({
    path: '/dashboard/',
    getParentRoute: () => ManagerLayoutRoute,
  } as any)

const appLayoutSettingsIndexRoute = appLayoutSettingsIndexImport.update({
  path: '/settings/',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutPrescriptionHubIndexRoute =
  appLayoutPrescriptionHubIndexImport.update({
    path: '/prescription-hub/',
    getParentRoute: () => appLayoutRoute,
  } as any)

const appLayoutPatientsIndexRoute = appLayoutPatientsIndexImport.update({
  path: '/patients/',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutInventoryIndexRoute = appLayoutInventoryIndexImport.update({
  path: '/inventory/',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutDashboardIndexRoute = appLayoutDashboardIndexImport.update({
  path: '/dashboard/',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutActivityIndexRoute = appLayoutActivityIndexImport.update({
  path: '/activity/',
  getParentRoute: () => appLayoutRoute,
} as any)

const appLayoutAccountsIndexRoute = appLayoutAccountsIndexImport.update({
  path: '/accounts/',
  getParentRoute: () => appLayoutRoute,
} as any)

const ManagerLayoutInventoryItemIdRoute =
  ManagerLayoutInventoryItemIdImport.update({
    path: '/inventory/$itemId',
    getParentRoute: () => ManagerLayoutRoute,
  } as any)

const ManagerLayoutEmployeePerformanceEmployeeIdRoute =
  ManagerLayoutEmployeePerformanceEmployeeIdImport.update({
    path: '/employee-performance/$employeeId',
    getParentRoute: () => ManagerLayoutRoute,
  } as any)

const appLayoutInventoryItemIdIndexRoute =
  appLayoutInventoryItemIdIndexImport.update({
    path: '/inventory/$itemId/',
    getParentRoute: () => appLayoutRoute,
  } as any)

const appLayoutAccountsRevenueIndexRoute =
  appLayoutAccountsRevenueIndexImport.update({
    path: '/accounts/revenue/',
    getParentRoute: () => appLayoutRoute,
  } as any)

const appLayoutAccountsProfitLossIndexRoute =
  appLayoutAccountsProfitLossIndexImport.update({
    path: '/accounts/profit-loss/',
    getParentRoute: () => appLayoutRoute,
  } as any)

const appLayoutAccountsCostOfGoodsIndexRoute =
  appLayoutAccountsCostOfGoodsIndexImport.update({
    path: '/accounts/cost-of-goods/',
    getParentRoute: () => appLayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(app)': {
      preLoaderRoute: typeof appImport
      parentRoute: typeof rootRoute
    }
    '/(app)/_layout': {
      preLoaderRoute: typeof appLayoutImport
      parentRoute: typeof appRoute
    }
    '/manager': {
      preLoaderRoute: typeof ManagerImport
      parentRoute: typeof rootRoute
    }
    '/manager/_layout': {
      preLoaderRoute: typeof ManagerLayoutImport
      parentRoute: typeof ManagerRoute
    }
    '/technician': {
      preLoaderRoute: typeof TechnicianImport
      parentRoute: typeof rootRoute
    }
    '/technician/_layout': {
      preLoaderRoute: typeof TechnicianLayoutImport
      parentRoute: typeof TechnicianRoute
    }
    '/barcode/': {
      preLoaderRoute: typeof BarcodeIndexImport
      parentRoute: typeof rootRoute
    }
    '/manager/': {
      preLoaderRoute: typeof ManagerIndexImport
      parentRoute: typeof ManagerImport
    }
    '/technician/': {
      preLoaderRoute: typeof TechnicianIndexImport
      parentRoute: typeof TechnicianImport
    }
    '/(auth)/change-password/': {
      preLoaderRoute: typeof authChangePasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/forgot-password/': {
      preLoaderRoute: typeof authForgotPasswordIndexImport
      parentRoute: typeof rootRoute
    }
    '/(auth)/login/': {
      preLoaderRoute: typeof authLoginIndexImport
      parentRoute: typeof rootRoute
    }
    '/manager/_layout/employee-performance/$employeeId': {
      preLoaderRoute: typeof ManagerLayoutEmployeePerformanceEmployeeIdImport
      parentRoute: typeof ManagerLayoutImport
    }
    '/manager/_layout/inventory/$itemId': {
      preLoaderRoute: typeof ManagerLayoutInventoryItemIdImport
      parentRoute: typeof ManagerLayoutImport
    }
    '/(app)/_layout/accounts/': {
      preLoaderRoute: typeof appLayoutAccountsIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/activity/': {
      preLoaderRoute: typeof appLayoutActivityIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/dashboard/': {
      preLoaderRoute: typeof appLayoutDashboardIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/inventory/': {
      preLoaderRoute: typeof appLayoutInventoryIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/patients/': {
      preLoaderRoute: typeof appLayoutPatientsIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/prescription-hub/': {
      preLoaderRoute: typeof appLayoutPrescriptionHubIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/settings/': {
      preLoaderRoute: typeof appLayoutSettingsIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/manager/_layout/dashboard/': {
      preLoaderRoute: typeof ManagerLayoutDashboardIndexImport
      parentRoute: typeof ManagerLayoutImport
    }
    '/manager/_layout/employee-performance/': {
      preLoaderRoute: typeof ManagerLayoutEmployeePerformanceIndexImport
      parentRoute: typeof ManagerLayoutImport
    }
    '/manager/_layout/inventory/': {
      preLoaderRoute: typeof ManagerLayoutInventoryIndexImport
      parentRoute: typeof ManagerLayoutImport
    }
    '/manager/_layout/prescriptions/': {
      preLoaderRoute: typeof ManagerLayoutPrescriptionsIndexImport
      parentRoute: typeof ManagerLayoutImport
    }
    '/manager/_layout/sales-and-revenue/': {
      preLoaderRoute: typeof ManagerLayoutSalesAndRevenueIndexImport
      parentRoute: typeof ManagerLayoutImport
    }
    '/technician/_layout/count-and-verify/': {
      preLoaderRoute: typeof TechnicianLayoutCountAndVerifyIndexImport
      parentRoute: typeof TechnicianLayoutImport
    }
    '/technician/_layout/dashboard/': {
      preLoaderRoute: typeof TechnicianLayoutDashboardIndexImport
      parentRoute: typeof TechnicianLayoutImport
    }
    '/technician/_layout/expiry-track/': {
      preLoaderRoute: typeof TechnicianLayoutExpiryTrackIndexImport
      parentRoute: typeof TechnicianLayoutImport
    }
    '/technician/_layout/request-and-receive/': {
      preLoaderRoute: typeof TechnicianLayoutRequestAndReceiveIndexImport
      parentRoute: typeof TechnicianLayoutImport
    }
    '/technician/_layout/worklist/': {
      preLoaderRoute: typeof TechnicianLayoutWorklistIndexImport
      parentRoute: typeof TechnicianLayoutImport
    }
    '/(app)/_layout/accounts/cost-of-goods/': {
      preLoaderRoute: typeof appLayoutAccountsCostOfGoodsIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/accounts/profit-loss/': {
      preLoaderRoute: typeof appLayoutAccountsProfitLossIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/accounts/revenue/': {
      preLoaderRoute: typeof appLayoutAccountsRevenueIndexImport
      parentRoute: typeof appLayoutImport
    }
    '/(app)/_layout/inventory/$itemId/': {
      preLoaderRoute: typeof appLayoutInventoryItemIdIndexImport
      parentRoute: typeof appLayoutImport
    }
  }
}

// Create and export the route tree

export const routeTree = rootRoute.addChildren([
  appRoute.addChildren([
    appLayoutRoute.addChildren([
      appLayoutAccountsIndexRoute,
      appLayoutActivityIndexRoute,
      appLayoutDashboardIndexRoute,
      appLayoutInventoryIndexRoute,
      appLayoutPatientsIndexRoute,
      appLayoutPrescriptionHubIndexRoute,
      appLayoutSettingsIndexRoute,
      appLayoutAccountsCostOfGoodsIndexRoute,
      appLayoutAccountsProfitLossIndexRoute,
      appLayoutAccountsRevenueIndexRoute,
      appLayoutInventoryItemIdIndexRoute,
    ]),
  ]),
  ManagerRoute.addChildren([
    ManagerLayoutRoute.addChildren([
      ManagerLayoutEmployeePerformanceEmployeeIdRoute,
      ManagerLayoutInventoryItemIdRoute,
      ManagerLayoutDashboardIndexRoute,
      ManagerLayoutEmployeePerformanceIndexRoute,
      ManagerLayoutInventoryIndexRoute,
      ManagerLayoutPrescriptionsIndexRoute,
      ManagerLayoutSalesAndRevenueIndexRoute,
    ]),
    ManagerIndexRoute,
  ]),
  TechnicianRoute.addChildren([
    TechnicianLayoutRoute.addChildren([
      TechnicianLayoutCountAndVerifyIndexRoute,
      TechnicianLayoutDashboardIndexRoute,
      TechnicianLayoutExpiryTrackIndexRoute,
      TechnicianLayoutRequestAndReceiveIndexRoute,
      TechnicianLayoutWorklistIndexRoute,
    ]),
    TechnicianIndexRoute,
  ]),
  BarcodeIndexRoute,
  authChangePasswordIndexRoute,
  authForgotPasswordIndexRoute,
  authLoginIndexRoute,
])

/* prettier-ignore-end */
